import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../utils";

export const stockReport = createAsyncThunk('stockReport', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `stock_report`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
                'department_id': data?.department_id,
                'equipment_id': data?.equipment_id,
                'part_number': data?.part_number,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const stockReportSlice = createSlice({
    name: 'stockReport',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(stockReport.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(stockReport.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default stockReportSlice.reducer;